import React, { useState, useEffect } from 'react';
import showNotification from '../component/Notification';
import baseURL from '../component/baseURL';
import { useNavigate } from 'react-router-dom';
import stringsoflanguages from '../component/stringsoflanguages';

const STORAGE_KEY = 'my_listing_contract_text';

export default function MyListingContract() {
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);
    const [draft, setDraft] = useState('');
    const [contractDetails, setContractDetails] = useState('');
    const [userID, setUserID] = useState('');

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid);
        fetchGetContractDetailsAPI(userid);
    }, []);

    const startEdit = () => {
        setDraft(contractDetails ?? '');
        setIsEditing(true);
    };

    const save = () => {
        const next = draft ?? '';
        setContractDetails(next);
        try {
            localStorage.setItem(STORAGE_KEY, next);
        } catch {
            /* ignore */
        }
        setIsEditing(false);
        showNotification('Success', 'Contract saved', 'success');
    };

    const cancelEdit = () => {
        setIsEditing(false);
        setDraft('');
    };

    function fetchGetContractDetailsAPI(userid) {
        const formdata = new FormData();
        formdata.append('user_id', userid);
        formdata.append('key', '81dc9bdb52d04dc20036dbd8313ed055');
        fetch(baseURL.URL + '/users/get_user_details', {
            method: 'POST',
            body: formdata
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.result_code === 200) {
                    const result = responseJson.response;
                    let next = result?.contract ?? '';
                    if (next === '') {
                        try {
                            const saved = localStorage.getItem(STORAGE_KEY);
                            if (saved != null && saved !== '') {
                                next = saved;
                            }
                        } catch {
                            /* ignore */
                        }
                    }
                    setContractDetails(next);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    function updateContract() {
        const next = draft ?? '';
        const formdata = new FormData();
        formdata.append('user_id', userID);
        formdata.append('key', '81dc9bdb52d04dc20036dbd8313ed055');
        formdata.append('contract', next);
        fetch(baseURL.URL + '/users/change', {
            method: 'POST',
            body: formdata
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.code === 200) {
                    setContractDetails(next);
                    try {
                        localStorage.setItem(STORAGE_KEY, next);
                    } catch {
                        /* ignore */
                    }
                    setIsEditing(false);
                    setDraft('');
                    showNotification('Success', 'Contract updated successfully', 'success');
                } else {
                    showNotification('Error', responseJson.server.message, 'error');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }


    return (
        <>
            <div className="search-filter-section my-listing-contract-search gap-2 justify-content-between mb-0">
                <div className='page-back-btn flex align-items-center'>
                    <button className='back-btn-icon' onClick={() => navigate('/home/my-listings')}>
                        <i className='fa-solid fa-arrow-left'></i>
                    </button>

                </div>
                {!isEditing ? (
                    <button type="button" className="my-listing-contract-edit-btn" onClick={startEdit}>
                        <i className="fa-solid fa-pen" aria-hidden="true" />
                        <span>{stringsoflanguages.edit}</span>
                    </button>
                ) : (
                    <div className="my-listing-contract-actions">
                        <button type="button" className="my-listing-contract-cancel-btn" onClick={cancelEdit}>
                            {stringsoflanguages.cancel}
                        </button>
                        <button type="button" className="my-listing-contract-save-btn" onClick={() => updateContract()}>
                            <i className="fa-solid fa-floppy-disk" aria-hidden="true" />
                            <span>{stringsoflanguages.save}</span>
                        </button>
                    </div>
                )}
            </div>
            <div className="content-right my-listings-page my-listing-contract-page">
                <div className="my-listing-contract-header">
                    <h1 className="my-listing-contract-title">{stringsoflanguages.termsAndConditions}</h1>

                </div>

                <div className="my-listing-contract-body">
                    {isEditing ? (
                        <textarea
                            className="my-listing-contract-textarea"
                            value={draft}
                            onChange={(e) => setDraft(e.target.value)}
                            rows={8}
                            spellCheck
                            aria-label="Contract text"
                        />
                    ) : (
                        <div className="my-listing-contract-text">{contractDetails}</div>
                    )}
                </div>
            </div>
        </>
    );
}
